import APP from './modules/app';
import GOOGLE from './modules/google';
import FILTERS from './modules/filters';
import NOTIFICATIONS from './modules/notifications';
import NOTES from './modules/notes';
import PROPERTY from './modules/property';
import AUTH from './modules/auth';
import DASHBOARD from './modules/dashboard';
import FILES from './modules/files';

export default {
  APP,
  GOOGLE,
  FILTERS,
  NOTIFICATIONS,
  NOTES,
  PROPERTY,
  AUTH,
  DASHBOARD,
  FILES,
};
